module.exports = __webpack_public_path__ + "static/media/sven-mieke-Lx_GDv7VA9M-unsplash.97e0a6b7.jpg";